import React from "react";
import { Outlet } from "react-router-dom";

const CertificateUpdate=()=>{
  return (
      <Outlet />
  );
};

export default CertificateUpdate
